import React from "react";
import { ILanguage } from "../../../common/interfaces";
import {
	Checkbox,
	TextField,
	Autocomplete,
} from "../../../common/MaterialComponent";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

export interface LanguageSelectionProps {
	onLanguageChange: (languages: ILanguage[]) => void;
	languageList: ILanguage[];
	selectedLanguages: ILanguage[];
	isReadOnly: boolean;
	requiresValidation?: boolean;
}

const LanguageSelection = (props: LanguageSelectionProps) => {
	const strings = useGetComponentStringsContext().LanguageSelection;
	function getSelectedLanguage() {
		return props.selectedLanguages;
	}
	return (
		<>
			<Autocomplete
				multiple
				onChange={(event: any, values: ILanguage[]) =>
					props.isReadOnly ? {} : props.onLanguageChange(values)
				}
				data-testid="languageSelection"
				options={props.languageList}
				value={getSelectedLanguage()}
				getOptionLabel={(option: ILanguage) => option.name}
				autoHighlight
				getOptionSelected={(option, value) => !value || option === value}
				getOptionDisabled={() => props.isReadOnly}
				disableClearable
				renderOption={(option: ILanguage, { selected }) => (
					<React.Fragment>
						<Checkbox color="primary" checked={selected} />
						{option.name}
					</React.Fragment>
				)}
				renderInput={(params) => (
					<TextField
						data-testid="languageInput"
						value={params}
						{...params}
						label={strings.selectLanguageLabel}
						error={
							getSelectedLanguage().length === 0 && props.requiresValidation
						}
						helperText={
							getSelectedLanguage().length === 0 && props.requiresValidation
								? strings.languageRequiredErrorMessage
								: ""
						}
						disabled={props.isReadOnly}
					/>
				)}
			/>
		</>
	);
};

export default LanguageSelection;
